package org.example.zone360.pages.widgets.helper

import com.varabyte.kobweb.compose.ui.graphics.Color
import org.example.zone360.theme.Palette

data class ScoreStatus(
    val text: String,
    val color: Color,
    val icon: String
)

fun getStatus(
    value: Int,
    minTarget: Int,
    maxTarget: Int
): ScoreStatus {

    return when {
        value in minTarget..maxTarget ->
            ScoreStatus(
                "Aligned",
                Palette.CoachTalkSuccessGreen.rgbLight,
                "✓"
            )

        value > maxTarget + 5 ->
            ScoreStatus(
                "High",
                Palette.CoachTalkSuccessGreen.rgbLight,
                "🔥"
            )

        value > maxTarget ->
            ScoreStatus(
                "Slightly High",
                Palette.AbsoluteOrange.rgbLight,
                "⚠"
            )

        value < minTarget - 5 ->
            ScoreStatus(
                "Low",
                Palette.CoachTalkErrorRed.rgbLight,
                "✕"
            )

        else ->
            ScoreStatus(
                "Slightly Low",
                Palette.AbsoluteOrange.rgbLight,
                "⚠"
            )
    }
}